import { Markup } from "interweave";
import React from "react";
import { Link } from "react-router-dom";
const SingleCardSchedule = ({
  id,
  eventType,
  post,
  title,
  description,
  image,
  date,
  time,
  link,
}) => {
  let participate = 0;
  if (eventType.title == "Audition") {
    participate = post?.participant?.length;
  }
  return (
    <>
      <div className="containerSa col-md-3 mb-3">
        <div className="ClassHeadApp">
          <div className="container-lg">
            <div className="ClassHeadC">
              <h5 className="Approved-C fw-bold">{date} </h5>
              <small className="text-light fw-bold">
                <i className="fa-solid fa-clock"></i> {time}{" "}
              </small>
              <p className="text-warning fw-bold">
                Participate : {participate}
              </p>
            </div>
          </div>
        </div>
        <div className="overlayASchedule bg-info ApprovedS">
          <Link to={link}>
            <div className="text-center">
              <button className="fw-bold text-light pb-3 mt-3">
                <i className="fa-solid fa-eye"></i>
              </button>
            </div>
          </Link>

          <div className="containerADS">
            <img src={image} alt="Snow" className="Img-Sch-Event " />

            {/* Background color */}
            <div className="LeftTopScA"> </div>
            {/* Background color */}

            <div className="LeftTopSc">
              <h5 className="mt-2 text-warning title-limit">{title}</h5>
              <Markup className="text-white des-limit" content={description} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleCardSchedule;
